import {
  buildApplyStageRoutePath,
  useDefineProviderRoute,
} from "@versatile-credit-apply/composition"
import { type RouteRecordRaw } from "vue-router"
import { type StaticProviderKey } from "@versatile-credit-apply/omni-apply-client"

const providerKey: StaticProviderKey = "fortiva_standard"
const { defineRoute } = useDefineProviderRoute(providerKey)

export const routes: RouteRecordRaw[] = [
  defineRoute({
    path: "/apply/:applyStage/responses/approved",
    inherit: true,
    component: () =>
      import("@/providers/fortiva_standard/views/FortivaApprovedView.vue"),
  }),

  defineRoute({
    path: "/apply/:applyStage/responses/prequalified",
    inherit: true,
    component: () =>
      import("@/providers/fortiva_standard/views/FortivaPrequalifiedView.vue"),
  }),

  defineRoute({
    path: "/apply/offer/terms",
    inherit: true,
    component: () =>
      import("@/providers/fortiva_standard/views/FortivaOfferTermsView.vue"),
  }),

  defineRoute({
    path: "/apply/prequalify/terms",
    inherit: true,
    redirect: (to) =>
      buildApplyStageRoutePath(to.params.providerKey as string, "/submit", {
        params: to.params,
      }),
  }),

  defineRoute({
    path: "/apply/responses/pending_offer",
    inherit: true,
    component: () =>
      import("@/providers/fortiva_standard/views/FortivaPendingView.vue"),
  }),
]
